const SearchFiltersLoader = () => {
    return (
        <div style={{marginTop: 20}}>
            <div style={{marginBottom: 40}}>
                <p  className="info_item_loader" style={{color: "rgba(0,0,0,0)", height: 30, fontSize: 16, fontFamily: "'Prompt', Sans-serif", width: "fit-content", fontWeight: "bolder", marginBottom: 10}}>
                    Important Notice
                </p>
                <p className="info_item_loader" style={{color: "rgba(0,0,0,0)", height: 30, fontSize: 14, width: 200}}>
                    Prices displayed include taxes
                </p>
            </div>
            <div style={{marginBottom: 40}}>
                <p  className="info_item_loader" style={{color: "rgba(0,0,0,0)", height: 30, fontSize: 16, fontFamily: "'Prompt', Sans-serif", width: "fit-content", fontWeight: "bolder", marginBottom: 10}}>
                    Important Notice
                </p>
                <p className="info_item_loader" style={{color: "rgba(0,0,0,0)", height: 30, fontSize: 14, width: 200}}>
                    Prices displayed include taxes
                </p>
            </div>
            <div style={{marginBottom: 40}}>
                <p  className="info_item_loader" style={{color: "rgba(0,0,0,0)", height: 30, fontSize: 16, fontFamily: "'Prompt', Sans-serif", width: "fit-content", fontWeight: "bolder", marginBottom: 10}}>
                    Important Notice
                </p>
                <p className="info_item_loader" style={{color: "rgba(0,0,0,0)", height: 30, fontSize: 14, width: 200}}>
                    Prices displayed include taxes
                </p>
            </div>
            <div style={{marginBottom: 40}}>
                <p  className="info_item_loader" style={{color: "rgba(0,0,0,0)", height: 30, fontSize: 16, fontFamily: "'Prompt', Sans-serif", width: "fit-content", fontWeight: "bolder", marginBottom: 10}}>
                    Important Notice
                </p>
                <p className="info_item_loader" style={{color: "rgba(0,0,0,0)", height: 30, fontSize: 14, width: 200}}>
                    Prices displayed include taxes
                </p>
            </div>
            <div style={{marginBottom: 40}}>
                <p  className="info_item_loader" style={{color: "rgba(0,0,0,0)", height: 30, fontSize: 16, fontFamily: "'Prompt', Sans-serif", width: "fit-content", fontWeight: "bolder", marginBottom: 10}}>
                    Important Notice
                </p>
                <p className="info_item_loader" style={{color: "rgba(0,0,0,0)", height: 30, fontSize: 14, width: 200}}>
                    Prices displayed include taxes
                </p>
            </div>
            <div style={{marginBottom: 40}}>
                <p  className="info_item_loader" style={{color: "rgba(0,0,0,0)", height: 30, fontSize: 16, fontFamily: "'Prompt', Sans-serif", width: "fit-content", fontWeight: "bolder", marginBottom: 10}}>
                    Important Notice
                </p>
                <p className="info_item_loader" style={{color: "rgba(0,0,0,0)", height: 30, fontSize: 14, width: 200}}>
                    Prices displayed include taxes
                </p>
            </div>
            <div style={{marginBottom: 40}}>
                <p  className="info_item_loader" style={{color: "rgba(0,0,0,0)", height: 30, fontSize: 16, fontFamily: "'Prompt', Sans-serif", width: "fit-content", fontWeight: "bolder", marginBottom: 10}}>
                    Important Notice
                </p>
                <p className="info_item_loader" style={{color: "rgba(0,0,0,0)", height: 30, fontSize: 14, width: 200}}>
                    Prices displayed include taxes
                </p>
            </div>
            <div style={{marginBottom: 40}}>
                <p  className="info_item_loader" style={{color: "rgba(0,0,0,0)", height: 30, fontSize: 16, fontFamily: "'Prompt', Sans-serif", width: "fit-content", fontWeight: "bolder", marginBottom: 10}}>
                    Important Notice
                </p>
                <p className="info_item_loader" style={{color: "rgba(0,0,0,0)", height: 30, fontSize: 14, width: 200}}>
                    Prices displayed include taxes
                </p>
            </div>
        </div>
    );
}

export default SearchFiltersLoader;